/**
 * Sinaliza que há colocações não exibidas entre a linha anterior e a próxima —
 * tipicamente entre o fim do topo do ranking e a linha do usuário logado.
 */
export const RankingGapDivider = () => (
  <p
    className="text-center text-lg font-bold leading-none text-gray-400"
    aria-hidden
  >
    ···
  </p>
)
